import { Box } from "@primer/react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { actions } from "../../state/actions/actionsWrapper";
import TreeList from "../../components/ui/tree-list";
import { DragContainer } from "../../components/ui/drag-container";
const HomePage = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.giaoVienNhanXet.loadStart())
  }, [])
  return (
    <Box sx={{ p: 3 }}>

      {/* <TreeList /> */}
      {/* <DragContainer
        onDropped={() => {

        }}
      >
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((x) => {
            return (
              <DragContainer.Dropable id={x.toString()} data={x}>
                <DragContainer.Draggable id={x.toString()} data={x}>
                  <Box sx={{ width: "200px", border: "1px solid", borderColor: "border.default", p: 3, height: "200px" }}>
                    {x}
                  </Box>
                </DragContainer.Draggable>
              </DragContainer.Dropable>
            );
          })}
        </Box>
      </DragContainer> */}

    </Box>

  );
}
export default HomePage
